module.exports = __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 164
// module chunks = 0